/**
 * Resource that represents an optional configuration key-value pair stored in the database.
 *
 * @name AppData
 * @class
 * @augments TmrResource
 */
export const factory = [
  'AppData',
  /*@ngInject*/ TmrResource => {
    /**
     * Loads a single configuration value.
     *
     * @method AppData#getValue
     */
    function getValue(code) {
      if (!code || typeof code !== 'string') {
        throw new Error(
          'AppData.getValue(code) action requires a configuration key (code)'
        )
      }
      return this.query({ code }).$promise.then(data =>
        data.length ? data[0].value : null
      )
    }

    /**
     * Loads multiple configuration values
     *
     * @method AppData#getValues
     */
    function getValues(codes) {
      if (!Array.isArray(codes) || !codes.length) {
        throw new Error(
          'AppData.getValues(codes) action requires an array of configuration keys (code)'
        )
      }
      return this.query({ code: codes }).$promise.then(data =>
        data.reduce(
          (values, { code, value }) => Object.assign(values, { [code]: value }),
          {}
        )
      )
    }

    let AppData = TmrResource('AppData')
    Object.assign(AppData, { getValue, getValues })

    return AppData
  },
]
